import { render, staticRenderFns } from "./ModalGroupListWorkflow.vue?vue&type=template&id=71c494e3&scoped=true&"
import script from "./ModalGroupListWorkflow.vue?vue&type=script&lang=js&"
export * from "./ModalGroupListWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./ModalGroupListWorkflow.vue?vue&type=style&index=0&id=71c494e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c494e3",
  null
  
)

export default component.exports